import { EuiFlexGroup, EuiFlexItem, EuiText, EuiTitle } from "@elastic/eui";
import { AddonDetailsCard } from "./AddonDetailsCard";
import { useEffect, useState } from "react";
import { useGetAddonsQuery } from "../../api/rtkQueryApi/AddonsApi";
import { Addon, AddonDetails } from "../../api/entities/Addon";
import { ConvertToAddonDetails } from "utils/ProductUtils";

export interface IAddonSelector {
  productGroupId: string;
  onAddonSelected: (addon: AddonDetails) => void;
}

export const AddonSelector: React.FC<IAddonSelector> = (props) => {
  const getAddonsQuery = useGetAddonsQuery();
  const [addons, setAddons] = useState<Addon[]>([]);
  const [filteredAddons, setFilteredAddons] = useState<Addon[]>([]);

  useEffect(() => {
    if (getAddonsQuery.data) {
      setAddons(getAddonsQuery.data);
    }
  }, [getAddonsQuery.data]);

  useEffect(() => {
    let fAddons = addons.filter((a) => {
      if (a.onlySpecialPricing) {
        if (props.productGroupId) {
          return a.specialPricingList?.some(
            (sp) => sp.productGroupId === props.productGroupId,
          );
        }
      }

      return true;
    });
    fAddons = fAddons.sort((a, b) => {
      const aSpecial =
        a.specialPricingList?.find(
          (sp) => sp.productGroupId === props.productGroupId,
        )?.price ?? 0;
      const bSpecial =
        b.specialPricingList?.find(
          (sp) => sp.productGroupId === props.productGroupId,
        )?.price ?? 0;

      return aSpecial - bSpecial;
    });

    setFilteredAddons(fAddons);
  }, [addons, props.productGroupId]);

  const onAddonSelected = (addon: AddonDetails) => {
    props.onAddonSelected(addon);
  };

  return (
    <>
      <EuiFlexGroup wrap justifyContent={"center"} alignItems={"center"}>
        {filteredAddons.length <= 0 && (
          <EuiFlexItem grow={false} style={{ alignSelf: "stretch" }}>
            <EuiTitle>
              <EuiText>No Available Addons</EuiText>
            </EuiTitle>
          </EuiFlexItem>
        )}
        {filteredAddons.map((addon) => {
          return (
            <EuiFlexItem
              grow={false}
              style={{ alignSelf: "stretch" }}
              key={addon.id}
            >
              <AddonDetailsCard
                addon={addon}
                onAddonSelected={() =>
                  onAddonSelected(ConvertToAddonDetails(addon))
                }
                productGroupId={props.productGroupId}
              />
            </EuiFlexItem>
          );
        })}
      </EuiFlexGroup>
    </>
  );
};
